import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

type Profile = {
  given_name?: string;
  family_name?: string;
  profile?: string;
};

export const useDOPermissions = () => {
  const { user, isAuthenticated } = useAuth();
  const tokenScopes = user?.scopes ?? [];
  const profile = (user?.profile ?? {}) as Profile;

  const hasDOScopes = useMemo(() => tokenScopes.some(s => s.includes('do:')), [tokenScopes]);
  const isAdmin = useMemo(() => tokenScopes.includes('do:digital-order:read:all'), [tokenScopes]);
  const canCreateDigitalOrder = useMemo(() => tokenScopes.includes('do:digital-order:upsert'), [
    tokenScopes,
  ]);

  const givenName = (profile.given_name ?? '').trim();
  const familyName = (profile.family_name ?? '').trim();
  const fullName = familyName ? `${givenName} ${familyName}` : givenName;
  const initialChars = familyName
    ? fullName
        .split(' ')
        .filter(part => part.length > 0)
        .map(part => part[0].toUpperCase())
    : fullName.substring(0, 2).toUpperCase();
  const initials = initialChars.length
    ? `${initialChars[0]}${initialChars[initialChars.length - 1]}`
    : '';

  return {
    isAuthenticated,
    user,
    isAdmin,
    hasDOScopes,
    canCreateDigitalOrder,
    fullName,
    initials,
    profileUrl: profile.profile ?? null,
  };
};
